
<template>
<div class="navigationDrawer" :data-visible="drawerVisible">
  <div class="navigationDrawer__body">
    <div class="closeBtn"><div></div></div>
    <div class="slideMenu">
    <div class="slideMenu__header">
      <a href="https://agaru.tv"><img src="/static/img/logo-menu-head.svg"/></a>
    </div>
    <template v-for="(group, gindex) in menuData">
      <template v-if="group.type === 'group' && group.enable">
        <div class="group__title" :key="`${gindex}${group.title}`">
          {{ group.title }}
        </div>
        <ul
          class="slideMenu__group"
          v-if="group.children.length > 0"
          :key="gindex"
        >
          <template v-for="(item, index) in group.children">
            <li
              v-if="item.enable"
              class="drawerContent__listItem"
              :key="`${index}${item.title}`"
              :class="{ disable: item.disableface }"
            >
              <a
                :href="item.url"
                :target="item.tgtBlank ? '_blank' : ''"
                @click="closeMenu"
                >{{ item.title }}
              </a>
            </li>
          </template>
        </ul>
      </template>
    </template>
    </div>
  </div>
  <div class="navigationDrawer__backDrop" @click="closeMenu">
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { UPDATE_MENU_VISIBILITY, LOGOUT } from '@/utvStore/store/mutation-types'

const path = path => `${window.location.origin}${path}`

export default {
  name: 'navigation-drawer',
  data() {
    return {
      location: encodeURIComponent(window.location.href),
      menuDataOrg: [
        {
          type: 'group',
          title: 'テレビ',
          enable: true,
          children: [
            {
              type: 'link',
              title: '放送中',
              url: 'https://agaru.tv/linear',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            },
            {
              type: 'link',
              title: '番組表',
              url: 'https://agaru.tv/timetable',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            },
            {
              type: 'link',
              title: '番組一覧',
              url: 'https://agaru.tv/program',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            }
          ]
        },
        {
          type: 'group',
          title: 'オンデマンド',
          enable: true,
          children: [
            {
              type: 'link',
              title: 'すべて',
              url: 'https://agaru.tv/movie',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            },
            {
              type: 'link',
              title: '人気の動画',
              url: 'https://agaru.tv/movie/genre/latest_highlight/',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            },
            {
              type: 'link',
              title: '恋愛・結婚',
              url: 'https://agaru.tv/movie/genre/love-marriage/',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            }
          ]
        },
        {
          type: 'group',
          title: 'ストア',
          enable: true,
          children: [
            {
              type: 'link',
              title: 'すべて',
              url: 'https://uranai.tv',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            }
          ]
        },
        {
          type: 'group',
          title: '購入アカウント',
          enable: true,
          children: [
            {
              type: 'link',
              title: '会員登録',
              url: `/user/login?show=signup?return_path=${location}`,
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              loggedin: 'disable',
              enable: true
            },
            {
              type: 'link',
              title: 'ログイン',
              url: `/user/login?show=signin?return_path=${location}`,
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              loggedin: 'disable',
              enable: true
            },
            {
              type: 'link',
              title: '登録情報',
              url: '/user/account',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              loggedin: 'visible',
              enable: true
            },
            {
              type: 'link',
              title: '購入履歴',
              url: '/payment/library',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              loggedin: 'visible',
              enable: true
            },
            {
              type: 'link',
              title: 'ログアウト',
              url: '/user/logout',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              loggedin: 'visible',
              enable: true
            }
          ]
        },
        {
          type: 'group',
          title: 'サポート',
          enable: true,
          children: [
            {
              type: 'link',
              title: 'よくある質問',
              url: 'https://agaru.tv/pre_faq',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            },
            {
              type: 'link',
              title: 'お問い合わせ',
              url: 'https://agaru.tv/pre_inquiry',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            },
            {
              type: 'link',
              title: 'お知らせ',
              url: 'https://agaru.tv/notifications',
              children: null,
              tgtBlank: false,
              gaEvent: null,
              disableface: false,
              enable: true
            }
          ]
        }
      ]
    }
  },
  computed: {
    menuData() {
      const res = []
      for (let item of this.menuDataOrg) {
        if (item.children.length > 0) {
          let childrens = []
          for (let citem of item.children) {
            let enb = false
            if (citem.enable) {
              enb = true
              if (citem.loggedin != null) {
                if (this.isLoggedIn) {
                  if (citem.loggedin === 'disable') {
                    enb = false
                  }
                } else {
                  if (citem.loggedin === 'visible') {
                    enb = false
                  }
                }
              }
            }
            childrens.push({
              type: citem.type,
              title: citem.title,
              url: citem.url,
              children: null,
              tgtBlank: citem.tgtBlank,
              gaEvent: null,
              disableface: citem.disableface,
              enable: enb
            })
          }
          if (childrens.length > 0) {
            res.push({
              type: item.type,
              title: item.title,
              enable: item.enable,
              children: childrens
            })
          }
        }
      }
      return res
    },
    ...mapState({
      drawerVisible: state => state.uiState.showMenu
    }),
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    closeMenu() {
      this.$store.dispatch(UPDATE_MENU_VISIBILITY, false)
    },
    logout() {
      this.closeMenu()
      this.$store.dispatch(LOGOUT)
    }
  }
}</script>

<style scoped lang="scss">
$color-white: white;
$color-dark-navy: #130d50;
$color-agaru-navy: #1b1464;
$baseSpeed: 300ms;
.slideMenu {
  background: $color-agaru-navy;
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 32px;
  overflow-y: auto;
  height: 100%;
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  &__header {
    width: 100%;
    padding: 24px;
  }
  .group__title {
    width: 100%;
    padding: 13px 16px;
    font-size: 14px;
    line-height: 14px;
    color: $color-white;
    background: $color-dark-navy;
    margin-bottom: 12px;
  }
  &__group {
    width: 100%;
    & > li {
      display: block;
      width: 100%;
      &:last-child {
        margin-bottom: 12px;
      }
      & > a {
        display: block;
        width: 100%;
        padding: 12px 24px;
        color: $color-white;
        font-weight: bold;
        font-size: 15px;
        line-height: 22px;
      }
    }
  }
}
.closeBtn {
  $btnW: 14px;
  display: block;
  width: $btnW;
  height: $btnW;
  position: absolute;
  right: -22px;
  top: 15px;
  opacity: 0;
  transition: opacity $baseSpeed ease-out 0s;
  pointer-events: none;
  div {
    width: 100%;
    height: 100%;
    position: relative;
    &::after,
    &::before {
      content: '';
      display: block;
      height: 2px;
      width: 15.62px;
      border-radius: 1px;
      background: white;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      transform-origin: 50% 50%;
    }
    &::after {
      transform: rotate(45deg);
    }
    &::before {
      transform: rotate(-45deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/NavigationDrawer.vue